import React from "react";
import { Link } from "react-router-dom";
import Logo from "../navbar/Logo";

const Footer = () => {
  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-12 pb-6 sm:pt-14 sm:pb-8">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-6 lg:gap-8">
          {/* Brand - full width on mobile & tablet */}
          <div className="col-span-2 sm:col-span-2 lg:col-span-1">
            <Link to="/" className="inline-block">
              <span className="inline-flex bg-white rounded-lg p-2 shadow">
                <Logo />
              </span>
            </Link>
            <p className="mt-3 text-lg font-semibold text-white">Pancham Records</p>
            <p className="mt-1 text-sm text-gray-400 leading-relaxed">
              Your destination for rare and classic music on vinyl, CD & more.
            </p>
          </div>

          {/* About */}
          <div>
            <h3 className="text-sm font-semibold text-white tracking-wide">About</h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/about-us" className="text-sm text-gray-400 hover:text-white transition">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="text-sm text-gray-400 hover:text-white transition">
                  Contact Us
                </Link>
              </li>
              <li>
                <button
                  onClick={() => window.dispatchEvent(new CustomEvent('openTestimonial'))}
                  className="text-sm text-gray-400 hover:text-white transition cursor-pointer bg-transparent border-none p-0"
                >
                  Write a Testimonial
                </button>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h3 className="text-sm font-semibold text-white tracking-wide">Policies</h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/tnc" className="text-sm text-gray-400 hover:text-white transition">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" className="text-sm text-gray-400 hover:text-white transition">
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-sm text-gray-400 hover:text-white transition">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cancellation-policy" className="text-sm text-gray-400 hover:text-white transition">
                  Cancellation Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact - full width on mobile & tablet */}
          <div className="col-span-2 lg:col-span-1">
            <h3 className="text-sm font-semibold text-white tracking-wide">Contact</h3>
            <ul className="mt-4 space-y-3 text-sm text-gray-400">
              <li>
                <a
                  href="mailto:sales@panchamrecords.com"
                  className="flex items-center gap-2.5 hover:text-white transition"
                >
                  <svg className="w-4 h-4 shrink-0 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  sales@panchamrecords.com
                </a>
              </li>
              <li>
                <a href="tel:+919422577724" className="flex items-center gap-2.5 hover:text-white transition">
                  <svg className="w-4 h-4 shrink-0 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  +91 9422577724
                </a>
              </li>
              <li>
                <a href="tel:+919422020363" className="flex items-center gap-2.5 hover:text-white transition">
                  <svg className="w-4 h-4 shrink-0 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  +91 9422020363
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/pancham_records/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2.5 hover:text-white transition"
                >
                  <svg className="w-4 h-4 shrink-0 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01M6.5 19h11a3 3 0 003-3V8a3 3 0 00-3-3h-11a3 3 0 00-3 3v8a3 3 0 003 3z" />
                  </svg>
                  @pancham_records
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-800 text-sm text-gray-500 text-center sm:text-left">
          © 2026 Pancham Records. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
